import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"

import { Provider } from "react-redux"

import store from "./store"
import { loadScript } from "utlis/loadExternalScript"
loadScript(
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyDr1UUVEHuq9Cu-Xs4-4hX-xqmM8qZ1_pw&libraries=places"
)
loadScript("https://editor.unlayer.com/embed.js")
const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()

